import $ from 'jquery';
import FJMathUtil from '../../util/FJMathUtil';
import { stagger } from 'animejs';
import { clamp } from 'lodash-es';
import EaseFunction from '../../common/module/EaseFunction';

/**
 * @desc 随机闪烁的数据
 * @type {*[]}
 */
const RANDOM_FLASHING_IN_DATA = [
    [
        { x: 0, y: 0 },
        { x: 0.3, y: 0.3 },
        { x: 0.5, y: 0.2 },
        { x: 0.7, y: 0.8 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.3, y: 0.15 },
        { x: 0.7, y: 0.7 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.3, y: 0.6 },
        { x: 0.6, y: 0.3 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.3, y: 0.1 },
        { x: 0.5, y: 0.5 },
        { x: 0.7, y: 1 },
        { x: 0.9, y: 0.8 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.5, y: 0.3 },
        { x: 0.7, y: 0.8 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.4, y: 0.3 },
        { x: 0.5, y: 1 },
        { x: 0.8, y: 0.6 },
        { x: 1, y: 1 },
    ],
];
const RANDOM_FLASHING_OUT_DATA = [
    [
        { x: 0, y: 1 },
        { x: 0.3, y: 0.8 },
        { x: 0.5, y: 0.2 },
        { x: 0.7, y: 0.3 },
        { x: 1, y: 0 },
    ],
    [
        { x: 0, y: 1 },
        { x: 0.3, y: 0.7 },
        { x: 0.7, y: 0.15 },
        { x: 1, y: 0 },
    ],
    [
        { x: 0, y: 1 },
        { x: 0.3, y: 0.3 },
        { x: 0.6, y: 0.6 },
        { x: 1, y: 0 },
    ],
    [
        { x: 0, y: 1 },
        { x: 0.3, y: 0.8 },
        { x: 0.5, y: 1 },
        { x: 0.7, y: 0.5 },
        { x: 0.9, y: 0.1 },
        { x: 1, y: 0 },
    ],
    [
        { x: 0, y: 1 },
        { x: 0.5, y: 0.8 },
        { x: 0.7, y: 0.3 },
        { x: 1, y: 0 },
    ],
    [
        { x: 0, y: 1 },
        { x: 0.4, y: 0.6 },
        { x: 0.5, y: 1 },
        { x: 0.8, y: 0.3 },
        { x: 1, y: 0 },
    ],
];

/**
 * @desc 随机弹出的数据
 * @type {([{x: number, y: number}, {x: number, y: number}, {x: number, y: number}, {x: number, y: number}, {x: number, y: number}]|[{x: number, y: number}, {x: number, y: number}, {x: number, y: number}, {x: number, y: number}]|[{x: number, y: number}, {x: number, y: number}, {x: number, y: number}, {x: number, y: number}]|[{x: number, y: number}, {x: number, y: number}, {x: number, y: number}, {x: number, y: number}, {x: number, y: number}, null]|[{x: number, y: number}, {x: number, y: number}, {x: number, y: number}, {x: number, y: number}])[]}
 */
const RANDOM_SCALE_DATA = [
    [
        { x: 0, y: 0 },
        { x: 0.3, y: 0.6 },
        { x: 0.5, y: 0.4 },
        { x: 0.7, y: 1.2 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.3, y: 0.3 },
        { x: 0.7, y: 1.2 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.3, y: 0.9 },
        { x: 0.6, y: 0.6 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.3, y: 0.2 },
        { x: 0.5, y: 1 },
        { x: 0.7, y: 1.2 },
        { x: 0.9, y: 0.9 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.5, y: 0.6 },
        { x: 0.7, y: 1.2 },
        { x: 1, y: 1 },
    ],
    [
        { x: 0, y: 0 },
        { x: 0.4, y: 0.6 },
        { x: 0.5, y: 1.2 },
        { x: 0.8, y: 0.8 },
        { x: 1, y: 1 },
    ],
];

/**
 * @descs 根据进度获取对应的数据上的2点间data.y的值，data.x为进度，data.y为这个进度上的值。x的范围（0 - 1）
 * @param progress - 当前进度
 * @param data1 - 当前进度的前一个数据节点
 * @param data1.x
 * @param data1.y
 * @param data2 - 当前进度的后一个数据节点
 * @param data2.x
 * @param data2.y
 * @return {*}
 * @constructor
 */
const getAnimationValueFromData = (progress, data1, data2) => {
    let angle = FJMathUtil.angleAtPoint(data2, data1);
    let l = progress - data1.x;
    let y = l / Math.tan(angle);
    return data1.y + y;
};

/**
 * @desc 更新blur
 * @param {array} targets - anime.animatables，在进行动画的对象数组
 * @param {number} blur - 最大的模糊度
 * @param {string} progressKey - 用于获取进度的key
 * @param {string} type - in | out, in为由模糊变清晰，out则反之
 * @constructor
 */
const updateBlurValue = (targets, blur = 0.2, progressKey, type = 'in') => {
    for (let i = 0; i < targets.length; i++) {
        let target = targets[i];
        let progress = target.getAttribute(progressKey);
        if (typeof progress !== 'undefined') {
            let value = blur * (type === 'in' ? 1 - progress : progress);
            target.style.filter = 'blur(' + value + 'em)';
        }
    }
};

const updateBounceOpacity = targets => {
    for (let i = 0; i < targets.length; i++) {
        let target = targets[i];
        let progress = target.getAttribute('bounce-progress');
        if (typeof progress !== 'undefined') {
            target.style.opacity = progress < 0.1 ? 0 : 1;
        }
    }
};

/**
 * @desc 随机闪烁
 * @param targets - anime.animatables，在进行动画的对象数组
 * @param progressKey - 用于获取进度的key
 * @param maxRandomLength - 允许存在最多多少个完全随机的动画，超过这个值后便和前一轮的随机值一样
 * @param type - in | out
 * @constructor
 */
const updateRandomOpacity = (targets, progressKey, maxRandomLength = 6, type = 'in') => {
    if (!targets) return;
    const maxCount = type === 'in' ? RANDOM_FLASHING_IN_DATA.length : RANDOM_FLASHING_OUT_DATA.length;
    maxRandomLength = Math.min(maxRandomLength, maxCount);
    for (let i = 0; i < targets.length; i++) {
        let target = targets[i];
        let progress = target.getAttribute(progressKey);
        if (typeof progress !== 'undefined') {
            let index = i % maxRandomLength;
            let dataList = type === 'in' ? RANDOM_FLASHING_IN_DATA[index] : RANDOM_FLASHING_OUT_DATA[index];
            for (let j = 1; j < dataList.length; j++) {
                if (dataList[j].x >= progress) {
                    target.style.opacity = getAnimationValueFromData(progress, dataList[j - 1], dataList[j]);
                    break;
                }
            }
        }
    }
};

/**
 * @desc 随机弹出动画
 * @param targets
 * @param progressKey - 用于获取进度的key
 * @param maxRandomLength - 允许存在最多多少个完全随机的动画，超过这个值后便和前一轮的随机值一样
 * @constructor
 */
const updateRandomScale = (targets, progressKey, maxRandomLength = 6) => {
    if (!targets) return;
    const maxCount = RANDOM_SCALE_DATA.length;
    maxRandomLength = Math.min(maxRandomLength, maxCount);
    for (let i = 0; i < targets.length; i++) {
        let target = targets[i];
        let progress = target.getAttribute(progressKey);
        if (typeof progress !== 'undefined') {
            let index = i % maxRandomLength;
            let dataList = RANDOM_SCALE_DATA[index];
            for (let j = 1; j < dataList.length; j++) {
                if (dataList[j].x > progress) {
                    let value = getAnimationValueFromData(progress, dataList[j - 1], dataList[j]);
                    $(target).css({
                        transform: `scaleY(${value})`,
                    });
                    break;
                }
            }
        }
    }
};

/**
 * @desc 更新光标
 * @param {array} targets - anime.animatables，在进行动画的对象数组
 * @param {{type: string, isClear: boolean, progressKey: string}} options
 * @param {string} options.type - in | out
 * @param {boolean} options.isClear - 是否是清除动画
 * @param {string} options.progressKey - 用于获取进度的key
 * @constructor
 */
const updateTypewriterCursor = (targets, { progress = -1, type, isClear, progressKey }) => {
    let cursorTargetIdx = null;
    let progressList = Array.from(targets).map(item => {
        return type === 'out' ? 1 - Number(item.getAttribute(progressKey)) : Number(item.getAttribute(progressKey));
    });

    // TODO 临时处理，因为动画时间线进度 只能到97 ，导致动画输出卡在最后一帧
    if (FJMathUtil.isValueEqual(progress, 100, 3)) {
        progress = 100;
    }
    if (type === 'in') {
        cursorTargetIdx = progressList.findLastIndex(item => item > 0);
    } else {
        progressList.reverse();
        cursorTargetIdx = progressList.findIndex(item => item < 1);
    }

    if (isClear || progress === 100 || progress === 0) {
        cursorTargetIdx = null;
    }

    for (let i = 0; i < targets.length; i++) {
        const target = targets[i];
        const cursor = $(target).find(`.${TYPEWRITER_CURSOR_CLASS_NAME}`);

        if (!isClear) {
            if (progressList[i] === 0) {
                $(target).css({ opacity: 0 });
            } else {
                $(target).css({ opacity: 1 });
            }
        }

        if (cursorTargetIdx === i) {
            cursor.css({ opacity: 1 });
        } else {
            cursor.css({ opacity: 0 });
        }
    }
};

const updateClarifyTranslateXValue = (targets, options) => {
    const { progressKey, ease = 'linear', type = 'in', clarityType = 'left' } = options;
    const progressList = targets.map(item => clamp(Number(item.getAttribute(progressKey)), 0, 1));
    const baseTranslateX = clarityType === 'left' ? -0.5 : 0.5;
    const easingFn = createEasingFn(ease);
    const avgProgress = progressList.reduce((acc, cur) => acc + cur, 0) / progressList.length;

    const min = Math.min(baseTranslateX, 0);
    const max = Math.max(baseTranslateX, 0);

    targets.forEach(item => {
        const target = item;
        const easingValue = easingFn(avgProgress);

        let translateValue = 0;
        if (type === 'in' && clarityType === 'left') {
            translateValue = min + easingValue * Math.abs(max - min);
        } else if (type === 'in' && clarityType === 'right') {
            translateValue = max - easingValue * Math.abs(max - min);
        } else if (type === 'out' && clarityType === 'left') {
            translateValue = max - easingValue * Math.abs(max - min);
        } else if (type === 'out' && clarityType === 'right') {
            translateValue = min + easingValue * Math.abs(max - min);
        }

        $(target).css({
            transform: `translateX(${translateValue}em)`,
        });
    });
};

const updateBlockValue = (targets, options = {}) => {
    const { type = 'in', isClear, progress = -1, textColor, direction = 'left' } = options;
    let target = updateBlockSliceEffect(targets, { color: textColor })[0];
    if (isClear || (progress === 100 && type !== 'out') || progress === 0) {
        destroyBlockSliceEffect(targets);
        return;
    }
    let clipPath = '';
    let opacity = 1;
    if (progress >= 50) {
        const clipValue = (progress - 50) * 2;
        switch (direction) {
            case 'left':
                clipPath = type === 'in' ? `inset(0 0 0 ${clipValue}% )` : `inset(0 ${clipValue}% 0 0)`;
                break;
            case 'right':
                clipPath = type === 'in' ? `inset(0 ${clipValue}% 0 0)` : `inset(0 0 0 ${clipValue}%)`;
                break;
            case 'top':
                clipPath = type === 'in' ? `inset(${clipValue}% 0 0 0)` : `inset(0 0 ${clipValue}% 0)`;
                break;
            case 'bottom':
                clipPath = type === 'in' ? `inset(0 0 ${clipValue}% 0)` : `inset(${clipValue}% 0 0 0)`;
                break;
            default:
                break;
        }

        $(target).css({ clipPath });
        opacity = type === 'in' ? 1 : 0;
    } else {
        const clipValue = (50 - progress) * 2;
        switch (direction) {
            case 'left':
                clipPath = type === 'in' ? `inset(0 ${clipValue}% 0 0)` : `inset(0 0 0 ${clipValue}%)`;
                break;
            case 'right':
                clipPath = type === 'in' ? `inset(0 0 0 ${clipValue}%)` : `inset(0 ${clipValue}% 0 0)`;
                break;
            case 'top':
                clipPath = type === 'in' ? `inset(0 0 ${clipValue}% 0)` : `inset(${clipValue}% 0 0 0)`;
                break;
            case 'bottom':
                clipPath = type === 'in' ? `inset(${clipValue}% 0 0 0)` : `inset(0 0 ${clipValue}% 0)`;
                break;
            default:
                break;
        }
        opacity = type === 'in' ? 0 : 1;
    }
    $(target).css({ clipPath });
    targets.forEach(item => {
        item.style.opacity = opacity;
    });
};

function createEasingFn(ease) {
    return (value, min = 0, max = 1) => {
        let fn = EaseFunction[ease];
        if (!fn) fn = EaseFunction.linear;
        return fn((value - min) / (max - min));
    };
}

const TYPEWRITER_CURSOR_CLASS_NAME = '__ANIMATION_EFFECT_TYPEWRITER_CURSOR__';

function updateTypewriterCursorEffect(targets, options = {}) {
    const { destroy, color, isTextEditMode } = options;
    if (destroy || isTextEditMode) {
        targets.forEach(target => {
            $(target).css({ visibility: 'visible' }).find(`.${TYPEWRITER_CURSOR_CLASS_NAME}`).remove();
        });
    } else {
        targets.forEach(target => {
            if ($(target).find(`.${TYPEWRITER_CURSOR_CLASS_NAME}`).length === 0) {
                const cursor = document.createElement('i');
                cursor.classList.add(TYPEWRITER_CURSOR_CLASS_NAME);
                target.append(cursor);
                $(target).css({ position: 'relative', visibility: 'visible', overflow: 'visible' });
                $(cursor).css({
                    backgroundColor: color || 'white',
                    position: 'absolute',
                    right: '-10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '10px',
                    height: '80%',
                    opacity: 0,
                });
            }
        });
    }
}

const BLOCK_SLICE_CLASS_NAME = '__ANIMATION_EFFECT_BLOCK_SLICE__';

function updateBlockSliceEffect(targets, options = {}) {
    const { color } = options;
    const target = targets[0];
    if (!target) return;

    let parent = null;
    while (true) {
        parent = (parent || targets[0]).parentElement;
        if (!parent || parent.classList.contains('fl-text-base')) {
            break;
        }
    }
    let newTargets = null;
    if ($(parent).find(`.${BLOCK_SLICE_CLASS_NAME}`).length === 0) {
        const slice = document.createElement('i');
        slice.classList.add(BLOCK_SLICE_CLASS_NAME);
        parent.append(slice);
        $(slice).css({
            backgroundColor: color,
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            // opacity: 0,
        });
        newTargets = [slice];
    } else {
        newTargets = [$(parent).find(`.${BLOCK_SLICE_CLASS_NAME}`)[0]];
    }

    return newTargets;
}
function destroyBlockSliceEffect(targets) {
    const target = targets[0];
    if (!target) return;

    let parent = null;
    while (true) {
        parent = (parent || targets[0]).parentElement;
        if (!parent || parent.classList.contains('fl-text-base')) {
            break;
        }
    }

    targets.forEach(target => {
        target.style.opacity = 1;
    });
    const blockSlice = $(parent).find(`.${BLOCK_SLICE_CLASS_NAME}`)[0];
    if (blockSlice) {
        $(blockSlice).remove();
    }
}

function updateClarifyEffectDOM(targets) {
    const shuffleFactor = '0.0.1';
    return FJMathUtil.shuffleArray(targets, shuffleFactor);
}

function getGridInfoHorizontalDistance(info, i, reverse = false) {
    let layerIndex = 0;
    let layerOffset = 0;
    for (let infoIndex = 0; infoIndex < info.length; infoIndex++) {
        // 取当前排的索引
        const sliceSum = info.slice(0, infoIndex + 1).reduce((a, b) => a + b, 0);
        if (sliceSum > i) {
            layerIndex = infoIndex;
            layerOffset = info[layerIndex] - (sliceSum - i);
            break;
        }
    }

    const layerLength = info[layerIndex];
    const staggerFn = stagger(1, {
        grid: [layerLength, 1],
        from: 'center',
        direction: reverse ? 'reverse' : 'normal',
    });
    const mid = Math.floor((layerLength + 1) / 2);
    const value = staggerFn(null, layerOffset, layerLength);
    return value !== 0 && layerOffset < mid ? -value : value;
}

function getTargetsGridInfo(targets) {
    const info = [];
    targets.forEach(target => {
        const layer = target.__TEXT_ANIMATION_LAYER__ || 0;
        info[layer] = info[layer] || 0;
        info[layer] = info[layer] + 1;
    });
    return info;
}

function getTargetsDuration(targets, { singleDuration, delayRate, speed }) {
    const info = getTargetsGridInfo(targets);
    const maxValue = Math.max(...info);

    let reduceInfo = 0;
    for (let i = 0; i < info.length; i++) {
        reduceInfo += info[i];
        if (info[i] === maxValue) {
            break;
        }
    }

    const distance = getGridInfoHorizontalDistance(info, reduceInfo - 1);
    return (1 + delayRate * distance) * (singleDuration * (1 / speed));
}

function getTargetsSpeedInDuration(targets, { singleDuration, delayRate, duration }) {
    const info = getTargetsGridInfo(targets);
    const maxValue = Math.max(...info);
    const distance = getGridInfoHorizontalDistance(info, maxValue - 1);
    return duration / ((1 + delayRate * distance) * singleDuration);
}
// 在播放的区间
function isInTimeZone(i, currentTime, wordTimestampList) {
    const curT = Math.round(currentTime * 10000) / 10000;
    const _startMs = wordTimestampList[i].startTime * 1000;
    const _endMs = (wordTimestampList[i].duration + wordTimestampList[i].startTime) * 1000;
    const startMs = Math.round(_startMs * 10000) / 10000; // 放宽区间，避免精度问题
    const endMs = Math.round(_endMs * 10000) / 10000; // 放宽区间，避免精度问题
    return curT >= startMs && curT < endMs;
}

const seededRandom = seed => {
    return () => {
        seed = (seed * 9301 + 49297) % 233280;
        return seed / 233280;
    };
};

function getFunnyKeyframes(keyframesLength, options = {}) {
    const {
        seed = keyframesLength, // 允许自定义种子
    } = options;

    const random = seededRandom(seed);

    return new Array(keyframesLength).fill(0).map((_, index) => ({
        rotate: index === keyframesLength - 1 || index === 0 ? 0 : (random() * 2 - 1) * 15,
        translateY: index === keyframesLength - 1 || index === 0 ? 0 : (random() * 2 - 1) * 10,
        translateX: index === keyframesLength - 1 || index === 0 ? 0 : (random() * 2 - 1) * 8,
    }));
}

function getOpacityKeyframes(keyframesLength, options = {}) {
    const {
        minOpacity = 0,
        maxOpacity = 1,
        seed = keyframesLength, // 允许自定义种子
    } = options;

    const random = seededRandom(seed);

    return new Array(keyframesLength).fill(0).map((_, index) => ({
        opacity: index === keyframesLength - 1 || index === 0 ? 1 : minOpacity + random() * (maxOpacity - minOpacity),
    }));
}

const updateFlickerRandomOpacity = (targets, progressKey, options = {}) => {
    if (!targets) return;
    const { singleDuration, showDuration, currentTime, forceProgress } = options;
    const keyframesLength = Math.ceil(showDuration / singleDuration) + 1;

    for (let i = 0; i < targets.length; i++) {
        let target = targets[i];
        let progress = forceProgress !== undefined ? forceProgress : target.getAttribute(progressKey);

        const preIndex = Math.min(Math.floor(currentTime / singleDuration), keyframesLength - 1);
        const nextIndex = Math.min(preIndex + 1, keyframesLength - 1);

        const keyframes = getOpacityKeyframes(keyframesLength, { seed: i });

        if (typeof progress !== 'undefined') {
            const preKeyframe = keyframes[preIndex];
            const nextKeyframe = keyframes[nextIndex];

            const opacity = getAnimationValueFromData(
                progress,
                { x: 0, y: preKeyframe.opacity },
                { x: 1, y: nextKeyframe.opacity },
            );
            target.style.opacity = opacity;
        }
    }
};

const updateFunnyRandom = (targets, progressKey, options = {}) => {
    if (!targets) return;
    const { singleDuration, showDuration, currentTime, forceProgress } = options;
    const keyframesLength = Math.ceil(showDuration / singleDuration) + 1;

    for (let i = 0; i < targets.length; i++) {
        let target = targets[i];
        let progress = forceProgress !== undefined ? forceProgress : target.getAttribute(progressKey);

        const preIndex = Math.min(Math.floor(currentTime / singleDuration), keyframesLength - 1);
        const nextIndex = Math.min(preIndex + 1, keyframesLength - 1);

        const keyframes = getFunnyKeyframes(keyframesLength, { seed: i });

        if (typeof progress !== 'undefined') {
            const preKeyframe = keyframes[preIndex];
            const nextKeyframe = keyframes[nextIndex];

            let transform = '';
            Object.keys(preKeyframe).forEach(key => {
                const value = getAnimationValueFromData(
                    progress,
                    { x: 0, y: preKeyframe[key] },
                    { x: 1, y: nextKeyframe[key] },
                );

                if (key === 'rotate') {
                    transform += `rotate(${value}deg)`;
                } else if (key === 'translateY') {
                    transform += `translateY(${value}px)`;
                } else if (key === 'translateX') {
                    transform += `translateX(${value}px)`;
                }
            });

            target.style.transform = transform;
        }
    }
};

/**
 * @desc 动画数据
 * @param {function} render - 在动画过程中需要修改元素的样式的方法
 * @param {string} progressKey - 如果有onUpdate,则是必要的属性，用于绑定在元素上用于获取进度
 * @param {number} delayRate - 逐个出现的延迟比例，指的是平均每个文字的动画播放时长的延迟比例，每个文字的延迟时间为 singleDuration * delayRate
 * @param {number} singleDuration - 单独的一个文字的播放时长
 * @param {number} maxLength - 最多有多少个文字进行动画
 * @param {{}} beginStyle - 当动画开始时需要设置的样式，注意当播放完成后有些样式需要删除，则在reset方法中删除
 * @param {boolean} isLoop - 是否是循环动画
 * @param {boolean} isExit - 是否是退场动画，退场动画必须加上
 * @param {function} customMotion - 自定义动画，如果需要自定义动画，则需要设置此属性
 * @param {*|function} customDelay - 自定义的延迟
 */
export default {
    GLOW_BLUR_IN: {
        scale: [2, 1],
        opacity: [0, 1],
        translateZ: 0,
        ease: 'linear',
        singleDuration: 200,
        delayRate: 0.1,
        combinationType: 'character',
        progressKey: 'glow-blur-in-progress',
        isIgnoreQueueMicrotask: true,
        // description: '由大到小，并带模糊',
        methods: {
            render: (targets, options = {}) => {
                updateBlurValue(targets, 0.1, 'glow-blur-in-progress');
            },
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'scale(2)',
                        opacity: 0,
                    });
                });
            },
        },
    },
    SCALE_DOWN: {
        scale: [3, 1],
        opacity: [0, 1],
        translateZ: 0,
        ease: 'linear',
        singleDuration: 200,
        delayRate: 0.2,
        combinationType: 'character',
        // description: '由大到小',
        methods: {
            initStyle: targets => {
                if (!targets) return;
                targets.forEach(target => {
                    $(target).css({
                        transform: 'scale(3)',
                        opacity: 0,
                    });
                });
            },
        },
    },
    LETTER_ZOOM: {
        scale: [0.3, 1],
        opacity: [0, 1],
        translateZ: 0,
        ease: 'outSine',
        singleDuration: 300,
        delayRate: 0.1,
        combinationType: 'character',
        // description: '由小变大',
        methods: {
            initStyle: targets => {
                if (!targets) return;
                targets.forEach(target => {
                    $(target).css({
                        transform: 'scale(0.3)',
                        opacity: 0,
                    });
                });
            },
        },
    },
    BLUR: {
        opacity: [0, 1],
        translateZ: 0,
        ease: 'linear',
        singleDuration: 200,
        delayRate: 0.2,
        combinationType: 'character',
        progressKey: 'blur-progress',
        isIgnoreQueueMicrotask: true,
        // description: '透明度变化，并带模糊效果',
        methods: {
            initStyle: targets => {
                if (!targets) return;
                targets.forEach(target => {
                    $(target).css({ opacity: 0 });
                });
            },
            render: (targets, options = {}) => {
                updateBlurValue(targets, 0.2, 'blur-progress');
            },
        },
    },
    REBOUND: {
        translateY: ['-0.5em', 0],
        opacity: [0, 1],
        ease: 'cubicBezier(.09,1.94,.56,.67)',
        translateZ: 0,
        singleDuration: 300,
        delayRate: 0.2,
        combinationType: 'character',
        progressKey: 'bounce-progress',
        // description: '由上到下，突然出现',
        methods: {
            initStyle: targets => {
                if (!targets) return;
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateY(-0.5em)',
                        opacity: 0,
                    });
                });
            },
            render: (targets, options = {}) => {
                updateBounceOpacity(targets);
            },
        },
    },
    BURST: {
        scale: [0, 1],
        elasticity: 600,
        singleDuration: 300,
        delayRate: 0.4,
        combinationType: 'character',
        // description: '由小变大，带有弹性',
        ease: 'outElastic(1, .5)', //对应 3.2.0 版本easing默认值
        methods: {
            initStyle: targets => {
                if (!targets) return;
                targets.forEach(target => {
                    $(target).css({ transform: 'scale(0)' });
                });
            },
        },
    },
    FADE: {
        opacity: [0, 1],
        ease: 'inOutQuad',
        singleDuration: 200,
        delayRate: 0.2,
        combinationType: 'character',
        // description: '透明度变化',
        methods: {
            initStyle: targets => {
                if (!targets) return;
                targets.forEach(target => {
                    $(target).css({
                        opacity: 0,
                    });
                });
            },
        },
    },
    SKATE: {
        translateY: ['101%', 0],
        translateX: ['55%', 0],
        translateZ: 0,
        rotateZ: [180, 0],
        ease: 'outExpo',
        singleDuration: 400,
        delayRate: 0.1,
        combinationType: 'character',
        options: {
            overflow: 'hidden',
        },
        // description: '由下到上旋转',
        methods: {
            updateTransformOrigin: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({ transformOrigin: 'left bottom' });
                });
            },
            initStyle: targets => {
                targets.forEach(target => {
                    if (!targets) throw new Error('no targets');
                    $(target).css({
                        transform: 'translateY(101%) translateX(55%) translateZ(0px) rotateZ(180deg)',
                    });
                });
            },
        },
    },
    WAVE: {
        translateY: ['101%', 0],
        translateZ: 0,
        singleDuration: 500,
        delayRate: 0.1,
        combinationType: 'character',
        ease: 'outElastic(1, .5)', //对应 3.2.0 版本easing默认值
        options: {
            overflow: 'hidden',
        },
        // description: '由下到上，弹性',
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateY(101%)',
                    });
                });
            },
        },
    },
    FLIP_LANDSCAPE: {
        rotateY: [-90, 0],
        translateZ: 0,
        singleDuration: 200,
        delayRate: 0.3,
        combinationType: 'character',
        // description: '横坐标翻转出现',
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'rotateY(-90deg)',
                    });
                });
            },
        },
    },
    CONTRACT: {
        translateX: ['1em', 0],
        translateZ: 0,
        opacity: [0, 1],
        ease: 'outExpo',
        singleDuration: 600,
        delayRate: 0.1,
        combinationType: 'character',
        // description: '从右往左出现',
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateX(1em)',
                        opacity: 0,
                    });
                });
            },
        },
    },

    CONTRACT_RIGHT: {
        translateX: ['-1em', 0],
        translateZ: 0,
        opacity: [0, 1],
        ease: 'outExpo',
        singleDuration: 600,
        delayRate: 0.1,
        combinationType: 'character',
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateX(-1em)',
                        opacity: 0,
                    });
                });
            },
            customDelay: (ele, i, l, options) => {
                const { delay } = options;
                return stagger(delay, {
                    start: 0,
                    from: 'last', // 从最后一个元素开始
                })(ele, i, l);
            },
        },
    },

    CONTRACT_DOWN: {
        translateY: ['-1em', 0],
        translateZ: 0,
        opacity: [0, 1],
        ease: 'outExpo',
        singleDuration: 600,
        delayRate: 0.1,
        combinationType: 'character',
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateY(-1em)',
                        opacity: 0,
                    });
                });
            },
        },
    },

    CONTRACT_UP: {
        translateY: ['1em', 0],
        translateZ: 0,
        opacity: [0, 1],
        ease: 'outExpo',
        singleDuration: 600,
        delayRate: 0.1,
        combinationType: 'character',
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateY(1em)',
                        opacity: 0,
                    });
                });
            },
        },
    },

    CLARIFY_IN_LEFT: {
        filter: [`blur(0.5em)`, 'blur(0em)'],
        opacity: [0, 1],
        ease: 'outCirc',
        singleDuration: 1500,
        delayRate: 0.05,
        combinationType: 'character',
        progressKey: 'clarify-in-left-progress',
        isIgnoreQueueMicrotask: true,
        // description: '随机模糊渐显-从左到右',
        methods: {
            render: (targets, options = {}) => {
                updateClarifyTranslateXValue(targets, {
                    progressKey: 'clarify-in-left-progress',
                    ease: 'inCirc',
                    type: 'in',
                    clarityType: 'left',
                });
            },
            updateEffectDOM: updateClarifyEffectDOM,
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateX(0.5em)',
                        filter: 'blur(0.5em)',
                        opacity: 0,
                    });
                });
            },
        },
    },
    CLARIFY_IN_RIGHT: {
        translateZ: 0,
        translateX: ['0.5em', '0em'],
        filter: [`blur(0.5em)`, 'blur(0em)'],
        opacity: [0, 1],
        ease: 'outCirc',
        singleDuration: 1500,
        delayRate: 0.05,
        combinationType: 'character',
        progressKey: 'clarify-in-right-progress',
        isIgnoreQueueMicrotask: true,
        // description: '随机模糊渐显-从右到左',
        methods: {
            render: (targets, options = {}) => {
                updateClarifyTranslateXValue(targets, {
                    progressKey: 'clarify-in-right-progress',
                    ease: 'inCirc',
                    type: 'in',
                    clarityType: 'right',
                });
            },
            updateEffectDOM: updateClarifyEffectDOM,
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateX(0.5em)',
                        filter: 'blur(0.5em)',
                        opacity: 0,
                    });
                });
            },
        },
    },
    CLARIFY_IN_CENTER: {
        scale: [0, 1],
        opacity: [0, 1],
        translateZ: [0, 0],
        filter: [`blur(0.5em)`, 'blur(0em)'],
        ease: 'outCirc',
        singleDuration: 1000,
        delayRate: 0.05,
        combinationType: 'character',
        isIgnoreQueueMicrotask: true,
        // description: '随机模糊渐显-从中心到四周',
        methods: {
            updateEffectDOM: updateClarifyEffectDOM,
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'scale(0)',
                        filter: 'blur(0.5em)',
                        opacity: 0,
                    });
                });
            },
        },
    },

    CLARIFY_OUT_LEFT: {
        isExit: true,
        translateX: ['0em', '-0.5em'],
        filter: [`blur(0em)`, 'blur(0.5em)'],
        opacity: [1, 0],
        ease: 'inCirc',
        singleDuration: 1500,
        delayRate: 0.05,
        combinationType: 'character',
        // description: '随机模糊渐隐-从左到右',
        progressKey: 'clarify-out-left-progress',
        isIgnoreQueueMicrotask: true,
        methods: {
            render: (targets, options = {}) => {
                updateClarifyTranslateXValue(targets, {
                    progressKey: 'clarify-out-left-progress',
                    ease: 'outCirc',
                    type: 'out',
                    clarityType: 'left',
                });
            },
            updateEffectDOM: updateClarifyEffectDOM,
        },
    },
    CLARIFY_OUT_RIGHT: {
        isExit: true,
        translateX: ['0em', '0.5em'],
        filter: [`blur(0em)`, 'blur(0.5em)'],
        opacity: [1, 0],
        ease: 'inCirc',
        singleDuration: 1500,
        delayRate: 0.05,
        combinationType: 'character',
        progressKey: 'clarify-out-right-progress',
        isIgnoreQueueMicrotask: true,
        // description: '随机模糊渐隐-从右到左',
        methods: {
            render: (targets, options = {}) => {
                updateClarifyTranslateXValue(targets, {
                    progressKey: 'clarify-out-right-progress',
                    ease: 'outCirc',
                    type: 'out',
                    clarityType: 'right',
                });
            },
            updateEffectDOM: updateClarifyEffectDOM,
        },
    },
    CLARIFY_OUT_CENTER: {
        isExit: true,
        scale: [1, 0],
        opacity: [1, 0],
        translateZ: [0, 0],
        filter: ['blur(0em)', `blur(0.5em)`],
        ease: 'inCirc',
        singleDuration: 1000,
        delayRate: 0.05,
        combinationType: 'character',
        // description: '随机模糊渐显-从中心到四周',
        isIgnoreQueueMicrotask: true,
        methods: {
            updateEffectDOM: updateClarifyEffectDOM,
        },
    },

    SHIFT: {
        translateY: ['-102%', 0],
        ease: 'outQuad',
        singleDuration: 200,
        delayRate: 0.2,
        combinationType: 'character',
        options: {
            overflow: 'hidden', // 不能把overflow设置为动画数据，否则会给每一个文字都设置overflow: hidden
        },
        // description: '由上到下, 缓慢出现',
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateY(-102%)',
                    });
                });
            },
        },
    },
    TYPEWRITER: {
        opacity: [0, 1],
        singleDuration: 120,
        delayRate: 1,
        combinationType: 'character',
        // description: '当一个文字显示后立马显示下一个',
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        opacity: 0,
                    });
                });
            },
        },
    },
    TYPEWRITER_CURSOR_IN: {
        singleDuration: 120,
        delayRate: 1,
        combinationType: 'character',
        progressKey: 'typewriter-cursor-in-progress',
        isIgnoreQueueMicrotask: true,
        // description: '当一个文字显示后立马显示下一个，并带有光标',
        methods: {
            render: (targets, options = {}) => {
                updateTypewriterCursor(targets, {
                    progress: options.progress,
                    type: 'in',
                    progressKey: 'typewriter-cursor-in-progress',
                });
            },
            onClear: (targets, options = {}) => {
                updateTypewriterCursor(targets, {
                    progress: options.progress,
                    type: 'in',
                    isClear: true,
                    progressKey: 'typewriter-cursor-in-progress',
                });
            },
            updateEffectDOM: (targets, options) => {
                updateTypewriterCursorEffect(targets, {
                    destroy: false,
                    color: options?.color,
                    isTextEditMode: options?.isTextEditMode,
                });
            },
            onDestroy: targets => {
                updateTypewriterCursorEffect(targets, { destroy: true });
            },
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        opacity: 0,
                    });
                });
            },
        },
    },
    TYPEWRITER_CURSOR_OUT: {
        singleDuration: 120,
        delayRate: 1,
        combinationType: 'character',
        progressKey: 'typewriter-cursor-out-progress',
        // description: '当一个文字显示后立马显示下一个，并带有光标',
        isIgnoreQueueMicrotask: true,
        isExit: true,
        methods: {
            render: (targets, options = {}) => {
                updateTypewriterCursor(targets, {
                    progress: options.progress,
                    type: 'out',
                    progressKey: 'typewriter-cursor-out-progress',
                });
            },
            onClear: targets => {
                updateTypewriterCursor(targets, {
                    type: 'out',
                    isClear: true,
                    progressKey: 'typewriter-cursor-out-progress',
                });
            },
            updateEffectDOM: (targets, options) => {
                updateTypewriterCursorEffect(targets, {
                    destroy: false,
                    color: options?.color,
                    isTextEditMode: options?.isTextEditMode,
                });
            },
            onDestroy: targets => {
                updateTypewriterCursorEffect(targets, { destroy: true });
            },
        },
    },
    GLITTER_IN: {
        maxLength: 6,
        opacity: [0, 0],
        ease: 'linear',
        singleDuration: 800,
        delayRate: 0,
        combinationType: 'character',
        progressKey: 'glitter-in-progress',
        // description: '随机闪烁出现',
        isIgnoreQueueMicrotask: true,
        methods: {
            render: (targets, options = {}) => {
                updateRandomOpacity(targets, 'glitter-in-progress');
            },
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        opacity: 0,
                    });
                });
            },
        },
    },
    GLITTER_OUT: {
        isExit: true,
        maxLength: 6,
        // opacity: [1, 0],
        ease: 'linear',
        singleDuration: 800,
        delayRate: 0,
        combinationType: 'character',
        progressKey: 'glitter-out-progress',
        isIgnoreQueueMicrotask: true,
        // description: '随机闪烁消失',
        methods: {
            render: targets => {
                updateRandomOpacity(targets, 'glitter-out-progress', 6, 'out');
            },
        },
    },
    RANDOM_JUMP: {
        maxLength: 6,
        ease: 'linear',
        opacity: [0, 1],
        beginStyle: {
            transformOrigin: 'center bottom',
        },
        singleDuration: 800,
        delayRate: 0,
        combinationType: 'character',
        progressKey: 'random-jump-progress',
        // description: '随机弹出',
        methods: {
            render: targets => {
                updateRandomScale(targets, 'random-jump-progress');
            },
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        opacity: 0,
                    });
                });
            },
        },
    },
    SWAY_LOOP: {
        maxLength: 2,
        isLoop: true,
        loop: true,
        // rotateZ: [0, 15],
        singleDuration: 600,
        delayRate: 0,
        combinationType: 'character',
        ease: 'linear',
        isIgnoreQueueMicrotask: true,
        progressKey: 'sway-loop-progress',
        // description: '左右2个循环旋转',
        methods: {
            customDelay: 0,
            render: (targets, options = {}) => {
                for (let i = 0; i < targets.length; i++) {
                    let target = targets[i];
                    const progress = target.getAttribute('sway-loop-progress') * 100;
                    let index = i % 2;
                    let value = progress >= 50 ? (index === 0 ? 15 : -15) : 0;
                    $(target).css({
                        transform: `rotateZ(${value}deg)`,
                    });
                }
            },
        },
    },
    JUMP_LOOP: {
        maxLength: 10,
        isLoop: true,
        loop: true,
        singleDuration: 400,
        delayRate: 0.1,
        combinationType: 'character',
        keyframes: [
            { translateY: '-0.4em', scaleY: 1.2 },
            { translateY: '0.4em', scaleY: 0.7 },
            { translateY: 0, scaleY: 1 },
        ],
        ease: 'linear',
        // description: '依次循环弹跳',
        methods: {
            customDelay: (ele, i, l, options) => {
                const { delay } = options;
                return (i % 10) * delay;
            },
            onClear: targets => {
                targets.forEach(target => {
                    $(target).css({
                        translateY: 0,
                        scaleY: 1,
                    });
                });
            },
        },
    },
    GLOW_BLUR_OUT: {
        isExit: true,
        scale: [1, 2],
        opacity: [1, 0],
        translateZ: 0,
        ease: 'linear',
        singleDuration: 200,
        delayRate: 0.1,
        combinationType: 'character',
        progressKey: 'glow-blur-progress',
        isIgnoreQueueMicrotask: true,
        // description: '由小到大退出，并带模糊',
        methods: {
            render: (targets, options = {}) => {
                updateBlurValue(targets, 0.1, 'glow-blur-progress', 'out');
            },
        },
    },
    SPREAD_INWARD: {
        ease: 'linear',
        singleDuration: 2500,
        delayRate: 0,
        disableDefaultDelayStagger: true,
        combinationType: 'character',
        // description: '从外向内压缩',
        methods: {
            customMotion: (targets, { duration = 0 }) => {
                const info = getTargetsGridInfo(targets);
                return {
                    translateX: (el, i) => {
                        const distance = getGridInfoHorizontalDistance(info, i);
                        return [`${distance * 0.25}em`, '0em'];
                    },
                    // opacity: {
                    //     value: [0, 1],
                    //     duration: duration * 0.3 || 750,
                    // },
                };
            },
        },
    },
    SPREAD_OUTWARD: {
        isExit: true,
        ease: 'linear',
        singleDuration: 2500,
        delayRate: 0,
        disableDefaultDelayStagger: true,
        combinationType: 'character',
        // description: '从内向外扩散',
        methods: {
            customMotion: (targets, { duration = 0 }) => {
                const info = getTargetsGridInfo(targets);
                return {
                    translateX: (el, i) => {
                        const distance = getGridInfoHorizontalDistance(info, i);
                        return ['0em', `${distance * 0.25}em`];
                    },
                    // opacity: {
                    //     value: [1, 0],
                    //     duration: duration * 0.3 || 750,
                    //     delay: duration * 0.7 || 1750,
                    // },
                };
            },
        },
    },
    SPREAD_INWARD_ZOOM: {
        ease: 'outCubic',
        scale: [5, 1],
        opacity: [0, 1],
        translateZ: [0, 0],
        singleDuration: 2500,
        delayRate: 0,
        disableDefaultDelayStagger: true,
        combinationType: 'character',
        // description: '从外向内压缩并缩放',
        methods: {
            customMotion: targets => {
                const info = getTargetsGridInfo(targets);
                return {
                    translateX: (el, i) => {
                        const distance = getGridInfoHorizontalDistance(info, i);
                        return [`${distance * 1.0}em`, '0em'];
                    },
                };
            },
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        opacity: 0,
                        transform: 'scale(5)',
                    });
                });
            },
        },
    },
    SPREAD_OUTWARD_ZOOM: {
        isExit: true,
        ease: 'inCubic',
        scale: [1, 5],
        opacity: [1, 0],
        singleDuration: 2500,
        delayRate: 0,
        disableDefaultDelayStagger: true,
        combinationType: 'character',
        // description: '从内向外扩散并缩放',
        methods: {
            customMotion: targets => {
                const info = getTargetsGridInfo(targets);
                return {
                    translateX: (el, i) => {
                        const distance = getGridInfoHorizontalDistance(info, i);
                        return ['0em', `${distance * 1.0}em`];
                    },
                };
            },
        },
    },

    FLY_IN: {
        ease: 'outCubic',
        opacity: [0, 1],
        translateY: ['-500%', 0],
        filter: ['blur(0.2em)', 'blur(0em)'],
        disableDefaultDelayStagger: true,
        singleDuration: 300,
        delayRate: 0.2,
        combinationType: 'character',
        // description: '从上到下下坠',
        methods: {
            customGetPlayDuration: getTargetsDuration,
            customGetSpeedInDuration: getTargetsSpeedInDuration,
            customMotion: (targets, options) => {
                const { delay } = options;
                const info = getTargetsGridInfo(targets);
                return {
                    translateX: (el, i) => {
                        const distance = getGridInfoHorizontalDistance(info, i);
                        return [`${distance * 0.3}em`, '0em'];
                    },
                    delay: (ele, i, l) => {
                        const distance = getGridInfoHorizontalDistance(info, i);
                        return Math.abs(distance) * delay;
                    },
                };
            },
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        opacity: 0,
                        transform: 'translateY(-500%)',
                        filter: 'blur(0.2em)',
                    });
                });
            },
        },
    },
    FLY_OUT: {
        isExit: true,
        ease: 'inCubic',
        opacity: [1, 0],
        translateY: [0, '-500%'],
        filter: ['blur(0em)', 'blur(0.2em)'],
        disableDefaultDelayStagger: true,
        singleDuration: 300,
        delayRate: 0.2,
        combinationType: 'character',
        // description: '从下到上浮出',
        methods: {
            customGetPlayDuration: getTargetsDuration,
            customGetSpeedInDuration: getTargetsSpeedInDuration,
            customMotion: (targets, options) => {
                const { delay } = options;
                const info = getTargetsGridInfo(targets);
                return {
                    translateX: (el, i) => {
                        const distance = getGridInfoHorizontalDistance(info, i);
                        return ['0em', `${distance * 0.3}em`];
                    },
                    delay: (ele, i, l) => {
                        const distance = getGridInfoHorizontalDistance(info, i, true);
                        return Math.abs(distance) * delay;
                    },
                };
            },
        },
    },

    BLOCK_IN_LEFT: {
        ease: 'linear',
        singleDuration: 500,
        // keyframes: [
        //     { clipPath: ['inset(0 100% 0 0)', 'inset(0 0% 0 0)'] },
        //     { clipPath: ['inset(0 0 0 0%)', 'inset(0 0% 0 100%)'] },
        // ],
        delayRate: 0,
        combinationType: 'character',
        // description: '从左到右划过覆盖层',
        isIgnoreQueueMicrotask: true,
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        overflow: 'visible',
                    });
                });
            },
            render: (targets, options = {}) => {
                updateBlockValue(targets, { ...options, type: 'in', direction: 'left' });
            },
            onClear: destroyBlockSliceEffect,
            onDestroy: destroyBlockSliceEffect,
        },
    },
    BLOCK_IN_TOP: {
        ease: 'linear',
        singleDuration: 800,
        delayRate: 0,
        combinationType: 'character',
        // description: '从上到下划过覆盖层',
        isIgnoreQueueMicrotask: true,
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        overflow: 'visible',
                    });
                });
            },
            render: (targets, options = {}) => {
                updateBlockValue(targets, { ...options, type: 'in', direction: 'top' });
            },
            onClear: destroyBlockSliceEffect,
            onDestroy: destroyBlockSliceEffect,
        },
    },
    BLOCK_IN_RIGHT: {
        ease: 'linear',
        singleDuration: 800,

        delayRate: 0,
        combinationType: 'character',
        // description: '从右到左划过覆盖层',
        isIgnoreQueueMicrotask: true,
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        overflow: 'visible',
                    });
                });
            },
            render: (targets, options = {}) => {
                updateBlockValue(targets, { ...options, type: 'in', direction: 'right' });
            },

            onClear: destroyBlockSliceEffect,
            onDestroy: destroyBlockSliceEffect,
        },
    },
    BLOCK_IN_BOTTOM: {
        ease: 'linear',
        singleDuration: 800,
        delayRate: 0,
        combinationType: 'character',
        // description: '从下到上划过覆盖层',
        isIgnoreQueueMicrotask: true,
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        overflow: 'visible',
                    });
                });
            },
            render: (targets, options = {}) => {
                updateBlockValue(targets, { ...options, type: 'in', direction: 'bottom' });
            },

            onClear: destroyBlockSliceEffect,
            onDestroy: destroyBlockSliceEffect,
        },
    },

    BLOCK_OUT_LEFT: {
        isExit: true,
        ease: 'linear',
        singleDuration: 800,
        opacity: [1, 0],
        delayRate: 0,
        combinationType: 'character',
        // description: '从右到左划过覆盖层',
        isIgnoreQueueMicrotask: true,
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        overflow: 'visible',
                    });
                });
            },
            render: (targets, options = {}) => {
                const progress = options.forceProgress !== undefined ? options.forceProgress : options.progress;
                updateBlockValue(targets, { ...options, type: 'out', direction: 'left', progress });
            },
            // onClear: destroyBlockSliceEffect,
            onDestroy: destroyBlockSliceEffect,
        },
    },
    BLOCK_OUT_TOP: {
        isExit: true,
        ease: 'linear',
        singleDuration: 800,
        delayRate: 0,
        combinationType: 'character',
        // description: '从下到上划过覆盖层',
        isIgnoreQueueMicrotask: true,
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        overflow: 'visible',
                    });
                });
            },
            render: (targets, options = {}) => {
                const progress = options.forceProgress !== undefined ? options.forceProgress : options.progress;
                updateBlockValue(targets, { ...options, type: 'out', direction: 'top', progress });
            },

            // onClear: destroyBlockSliceEffect,
            onDestroy: destroyBlockSliceEffect,
        },
    },
    BLOCK_OUT_RIGHT: {
        isExit: true,
        ease: 'linear',
        singleDuration: 800,
        delayRate: 0,
        combinationType: 'character',
        // description: '从右到左划过覆盖层',
        isIgnoreQueueMicrotask: true,
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        overflow: 'visible',
                    });
                });
            },
            render: (targets, options = {}) => {
                const progress = options.forceProgress !== undefined ? options.forceProgress : options.progress;
                updateBlockValue(targets, { ...options, type: 'out', direction: 'right', progress });
            },

            // onClear: destroyBlockSliceEffect,
            onDestroy: destroyBlockSliceEffect,
        },
    },
    BLOCK_OUT_BOTTOM: {
        isExit: true,
        ease: 'linear',
        singleDuration: 800,
        delayRate: 0,
        combinationType: 'character',
        // description: '从下到上划过覆盖层',
        isIgnoreQueueMicrotask: true,
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        overflow: 'visible',
                    });
                });
            },
            render: (targets, options = {}) => {
                const progress = options.forceProgress !== undefined ? options.forceProgress : options.progress;
                updateBlockValue(targets, { ...options, type: 'out', direction: 'bottom', progress });
            },
            // onClear: destroyBlockSliceEffect,
            onDestroy: destroyBlockSliceEffect,
        },
    },

    // 以下是字幕动画
    BACKGROUND_MOVE: {
        borderRadius: '12px',
        combinationType: 'word',
        singleDuration: 10,
        delayRate: 1,
        // description: '背景移动',
        isSubtitleAnimation: true,
        methods: {
            render: (targets, options = {}) => {
                const { currentTime, wordTimestampList, animationBackgroundColor } = options;
                for (let i = 0; i < targets.length; i++) {
                    if (isInTimeZone(i, currentTime, wordTimestampList)) {
                        targets[i].style.backgroundColor = animationBackgroundColor;
                    } else {
                        targets[i].style.backgroundColor = 'transparent';
                    }
                }
            },
        },
    },
    BACKGROUND_MOVE_AND_COLOR_CHANGE: {
        borderRadius: '12px',
        combinationType: 'word',
        singleDuration: 10,
        delayRate: 1,
        // description: '背景和字体颜色移动',
        isSubtitleAnimation: true,
        methods: {
            render: (targets, options = {}) => {
                const { textColor, animationTextColor, animationBackgroundColor, currentTime, wordTimestampList } =
                    options;
                if (!textColor) return;
                for (let i = 0; i < targets.length; i++) {
                    if (isInTimeZone(i, currentTime, wordTimestampList)) {
                        $(targets[i]).css({ backgroundColor: animationBackgroundColor, color: animationTextColor });
                    } else {
                        $(targets[i]).css({ backgroundColor: 'transparent', color: textColor });
                    }
                }
            },
        },
    },
    TEXT_SCALE: {
        keyframes: [
            { color: '#e9ff08', opacity: 1, scale: 1.1 },
            { color: '#e9ff08', opacity: 1, scale: 1.25 },
            { color: '#e9ff08', opacity: 1, scale: 1 },
        ],
        singleDuration: 300,
        delayRate: 1,
        ease: 'cubicBezier(0.835, 0.150, 0.230, 0.945)',
        combinationType: 'word',
        // description: '文字放大出现后缩小成正常值，透明度，颜色直接改变',
        isSubtitleAnimation: true,
        methods: {
            render: (targets, options = {}) => {
                const { textColor, animationTextColor, currentTime, wordTimestampList } = options;
                if (!textColor) return;
                for (let i = 0; i < targets.length; i++) {
                    if (isInTimeZone(i, currentTime, wordTimestampList)) targets[i].style.color = animationTextColor;
                    else targets[i].style.color = textColor;
                }
            },
        },
    },
    COLOR_CHANGE: {
        singleDuration: 10,
        delayRate: 1,
        combinationType: 'word',
        // description: '只有当前时间的文字颜色直接改变',
        isSubtitleAnimation: true,
        methods: {
            render: (targets, options = {}) => {
                const { textColor, animationTextColor, currentTime, wordTimestampList } = options;
                if (!textColor) return;

                for (let i = 0; i < targets.length; i++) {
                    if (isInTimeZone(i, currentTime, wordTimestampList)) targets[i].style.color = animationTextColor;
                    else targets[i].style.color = textColor;
                }
            },
        },
    },
    UP: {
        translateY: ['200%', 0],
        singleDuration: 500,
        delayRate: 1,
        combinationType: 'word',
        ease: 'inOutCirc',
        // description: '上浮',
        overflow: 'hidden',
        methods: {
            initStyle: targets => {
                if (!targets) throw new Error('no targets');
                targets.forEach(target => {
                    $(target).css({
                        transform: 'translateY(200%)',
                    });
                });
            },
        },
    },

    SCALE_UP_LOOP: {
        isLoop: true,
        singleDuration: 200,
        delayRate: 0.2,
        combinationType: 'character',
        ease: 'linear',
        keyframes: [{ scale: 1.4 }, { scale: 1 }],

        // description: '依次循环放大',
        methods: {
            customDelay: (ele, i, l, options) => {
                const { delay } = options;
                return i * delay;
            },
        },
    },

    FLICKER_RANDOM_LOOP: {
        singleDuration: 300,
        isLoop: true,
        combinationType: 'character',
        progressKey: 'flicker-random-progress',
        methods: {
            render: (targets, options = {}) => {
                updateFlickerRandomOpacity(targets, 'flicker-random-progress', options);
            },
        },
        // description: '文字故障闪烁',
        isIgnoreQueueMicrotask: true,
    },

    TEXT_FUNNY_LOOP: {
        singleDuration: 300,
        isLoop: true,
        combinationType: 'character',
        progressKey: 'wandering-random-progress',
        methods: {
            render: (targets, options = {}) => {
                updateFunnyRandom(targets, 'wandering-random-progress', options);
            },
        },
        ease: 'linear',
        // description: '文字调皮缓动',
        isIgnoreQueueMicrotask: true,
    },

    TEXT_SWING_LOOP: {
        isLoop: true,
        singleDuration: 400,
        coverFrameRate: 0.25,
        combinationType: 'character',
        delayRate: 0,
        transformOrigin: [
            { from: '50% 100%', to: '50% 100%', ease: 'inOutCubic' },
            { from: '50% 100%', to: '50% 100%', ease: 'inOutCubic' },
        ],
        rotate: [
            { from: 20, to: -20, ease: 'inOutCubic' },
            { from: -20, to: 20, ease: 'inOutCubic' },
        ],
        methods: {},
        // description: '文字摇摆',
    },

    TEXT_ROLL_IN: {
        translateY: [
            { from: '0%', to: '100%', duration: 0.1875 },
            { from: '-100%', to: '0%', duration: 0.125 },
            { from: '0%', to: '100%', duration: 0.09375 },
            { from: '-100%', to: '0%', duration: 0.0625 },
            { from: '0%', to: '100%', duration: 0.0625 },
            { from: '-100%', to: '0%', duration: 0.09375 },
            { from: '0%', to: '100%', duration: 0.125 },
            { from: '-100%', to: '0%', duration: 0.25, ease: 'outBack' },
        ],
        opacity: [{ from: 0, to: 1, duration: 1 }],
        ease: 'easeInOutCubic',
        singleDuration: 1000,
        delayRate: 0,
        options: {
            overflow: 'hidden',
        },
        multipleDirection: {
            up: {
                translateY: [
                    { from: '0', to: '100%', duration: 0.1875 },
                    { from: '100%', to: '200%', duration: 0.125 },
                    { from: '0%', to: '100%', duration: 0.09375 },
                    { from: '100%', to: '200%', duration: 0.0625 },
                    { from: '0%', to: '100%', duration: 0.0625 },
                    { from: '100%', to: '200%', duration: 0.09375 },
                    { from: '0%', to: '100%', duration: 0.125 },
                    { from: '100%', to: '200%', duration: 0.25, ease: 'outBack' },
                ],
                opacity: [0, 1],
                ease: 'easeInOutCubic',
                singleDuration: 1000,
                delayRate: 0,
                methods: {},
            },
        },
        methods: {},
        combinationType: 'character',
    },
    TEXT_ROLL_OUT: {
        translateY: [
            { from: '0%', to: '100%', duration: 0.1875 },
            { from: '-100%', to: '0%', duration: 0.125 },
            { from: '0%', to: '100%', duration: 0.09375 },
            { from: '-100%', to: '0%', duration: 0.0625 },
            { from: '0%', to: '100%', duration: 0.0625 },
            { from: '-100%', to: '0%', duration: 0.09375 },
            { from: '0%', to: '100%', duration: 0.125 },
            { from: '-100%', to: '0%', duration: 0.24, ease: 'outBack' },
            { from: '0%', to: '0%', duration: 0.01, ease: 'outBack' },
        ],
        opacity: [1, 0],
        ease: 'easeInOutCubic',
        singleDuration: 1000,
        delayRate: 0,
        options: {
            overflow: 'hidden',
        },
        multipleDirection: {
            up: {
                translateY: [
                    { from: '0', to: '100%', duration: 0.1875 },
                    { from: '100%', to: '200%', duration: 0.125 },
                    { from: '0%', to: '100%', duration: 0.09375 },
                    { from: '100%', to: '200%', duration: 0.0625 },
                    { from: '0%', to: '100%', duration: 0.0625 },
                    { from: '100%', to: '200%', duration: 0.09375 },
                    { from: '0%', to: '100%', duration: 0.125 },
                    { from: '100%', to: '200%', duration: 0.25, ease: 'outBack' },
                ],
                opacity: [1, 0],
                ease: 'easeInOutCubic',
                singleDuration: 1000,
                delayRate: 0,
                methods: {},
            },
        },
        methods: {},
        combinationType: 'character',
    },

    TEXT_ROLL_SLOW_IN: {
        translateY: [
            // 第一阶段：起始加速 (总时长: 0.11)
            { from: '0%', to: '100%', duration: 0.065, ease: 'easeInSine' },
            { from: '-100%', to: '0%', duration: 0.045 },
            // 第二阶段：中速过渡 (总时长: 0.22)
            { from: '0%', to: '100%', duration: 0.02 },
            { from: '-100%', to: '0%', duration: 0.02 },
            { from: '0%', to: '100%', duration: 0.02 },
            { from: '-100%', to: '0%', duration: 0.02 },
            { from: '0%', to: '100%', duration: 0.02 },
            { from: '-100%', to: '0%', duration: 0.02 },
            { from: '0%', to: '100%', duration: 0.04 },
            { from: '-100%', to: '0%', duration: 0.06 },
            // 第三阶段：渐进减速 (总时长: 0.18)
            { from: '0%', to: '100%', duration: 0.08, ease: 'linear' },
            { from: '-100%', to: '0%', duration: 0.1, ease: 'linear' },
            // 第四阶段：缓慢结尾 (总时长: 0.495)
            { from: '0%', to: '100%', duration: 0.195, ease: 'linear' },
            { from: '-100%', to: '0%', duration: 0.295, ease: 'cubic-bezier(0.25, 0.1, 0.25, 1)' },
        ],
        opacity: [0, 1],
        ease: 'easeInOutCubic',
        // TODO： 改成3000会存在输出过程中先出发动画完成方法，再出发动画内更新的情况，导致动画被错误初始化
        singleDuration: 2999,
        delayRate: 0,
        options: {
            overflow: 'hidden',
        },
        multipleDirection: {
            up: {
                translateY: [
                    // 第一阶段：起始加速 (总时长: 0.11)
                    { from: '0%', to: '100%', duration: 0.065, ease: 'easeInSine' },
                    { from: '100%', to: '200%', duration: 0.045 },
                    // 第二阶段：中速过渡 (总时长: 0.22)
                    { from: '0%', to: '100%', duration: 0.02 },
                    { from: '100%', to: '200%', duration: 0.02 },
                    { from: '0%', to: '100%', duration: 0.02 },
                    { from: '100%', to: '200%', duration: 0.02 },
                    { from: '0%', to: '100%', duration: 0.02 },
                    { from: '100%', to: '200%', duration: 0.02 },
                    { from: '0%', to: '100%', duration: 0.04 },
                    { from: '100%', to: '200%', duration: 0.06 },
                    // 第三阶段：渐进减速 (总时长: 0.18)
                    { from: '0%', to: '100%', duration: 0.08, ease: 'linear' },
                    { from: '100%', to: '200%', duration: 0.1, ease: 'linear' },
                    // 第四阶段：缓慢结尾 (总时长: 0.495)
                    { from: '0%', to: '100%', duration: 0.195, ease: 'linear' },
                    { from: '100%', to: '200%', duration: 0.295, ease: 'cubic-bezier(0.25, 0.1, 0.25, 1)' },
                ],
                opacity: [0, 1],
                ease: 'easeInOutCubic',
                singleDuration: 3000,
                delayRate: 0,
                methods: {},
            },
        },
        methods: {
            goToCoverFrame: targets => {
                targets.forEach(target => {
                    target.style.display = 'none';
                });
            },
        },
        combinationType: 'character',
    },

    TEXT_NEWS_LEFT_LOOP: {
        translateX: [
            { from: '0%', to: '-100%' },
            { from: '100%', to: '0%' },
        ],
        options: {
            overflow: 'hidden',
        },
        multipleDirection: {
            right: {
                translateX: [
                    { from: '0%', to: '-100%' },
                    { from: '-100%', to: '-200%' },
                ],
                isLoop: true,
                opacity: [1, 1],
                ease: 'linear',
                singleDuration: 2000,
                delayRate: 0,
                methods: {},
            },
        },
        ease: 'linear',
        isLoop: true,
        singleDuration: 2000,
        coverFrameRate: 0,
        delayRate: 0,
        methods: {},
        combinationType: 'character',
    },
};
